import { ReactNode, FC } from 'react';
import { Space } from 'src/utils/theme';
import * as S from './styles';

interface ListProps {
  containerHeight?: Space;
  children?: ReactNode;
}

// NOTE! This component is currently a placeholder.
// It has been constructed so that a minimal API is
// available but it will likely need to be modified
// in the future, particularly for styling purposes.
//
// Some props that may be added:
// - spacing (like a stack)
// - addSpace - What happens when the items do not reach the set height?

/**
 * The <List /> renders rows of data in a scrollable container
 *
 * It takes strong inspiration from SwifUI's List view
 * https://developer.apple.com/documentation/swiftui/list
 */
export const List: FC<ListProps> = ({ children, containerHeight, ...props }) => {
  return (
    <S.Container $containerHeight={containerHeight} {...props}>
      {children}
    </S.Container>
  );
};
